var classes = {
  "accordionButton": "accordionButton__Jh6JA",
  "icon": "icon__xwpzX"
};
export { classes as default };